module.exports = __webpack_public_path__ + "media/assets/images/kousaku-cloud-logo-144c1c3976d8f4639e845f59daacc57e.png";